<template>
  <div class="QA-molecule">
    <div class="QA-molecule__questions">
      <div v-for="(QA, index) in currentQAList" :key="index" class="QA-molecule__questions__wrapper">
        <p class="QA-molecule__questions__wrapper__question" @click="toggleAnswer(index)">
          <i
            class="bi"
            :class="{
              'bi-chevron-down': shownAnswer === index,
              'bi-chevron-right': shownAnswer !== index,
            }"
          ></i>
          {{ QA.q }}
        </p>
        <div v-if="shownAnswer === index">
          <p class="QA-molecule__questions__wrapper__answer" v-if="QA.a" v-html="QA.a"></p>

          <ul class="QA-molecule__questions__wrapper__answer" v-if="QA.aList">
            <li class="QA-molecule__questions__wrapper__listAnswer" v-for="(item, itemIndex) in QA.aList" :key="itemIndex">{{ item }}</li>
          </ul>
          <p class="QA-molecule__questions__wrapper__answer" v-if="QA.b">{{ QA.b }}</p>
          <ul class="QA-molecule__questions__wrapper__answer" v-if="QA.bList">
            <li class="QA-molecule__questions__wrapper__listAnswer" v-for="(item, itemIndex) in QA.bList" :key="itemIndex">{{ item }}</li>
          </ul>
          <p class="QA-molecule__questions__wrapper__answer" v-if="QA.c">{{ QA.c }}</p>
          <p class="QA-molecule__questions__wrapper__answer" v-if="QA.d">{{ QA.d }}</p>

          <a v-if="QA.aLink" :href="QA.aLink.link" target="_blank" class="QA-molecule__questions__wrapper_link"> {{ QA.aLink.text }} </a>
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { inject, computed } from 'vue';
export default {
  name: 'QAMolecule',
  setup() {
    const language = inject('language'); // Get the current language from context
    const isEnglish = computed(() => language.value === 'en'); // Check if it's English

    return {
      isEnglish,
    };
  },
  data() {
    return {
      shownAnswer: false,
      QAListSwedish: [
        {
          q: 'Om Byggutsläppslistan',
          a: 'Byggutsläppslistan är en hemsida som för första gången i världen publicerar utsläppen av CO2e från nybyggnation på projektnivå. BU-listan redovisar utsläpp kopplade till svenska byggprojekt – på projektnivå, kommunnivå och byggherrenivå.',
          b: 'Datan som publiceras är hämtad från Boverket och är baserad på de klimatdeklarationer som byggherrar, sedan januari 2022, enligt lag är skyldiga att göra för nybyggnation.',
          aLink: {
            text: 'Läs mer här',
            link: 'https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/',
          },
        },
        {
          q: 'Bakgrund',
          a: 'I Sverige är det sedan 1 januari 2022 ett krav vid nybyggnation att lämna in en klimatdeklaration som redovisar vilken påverkan på klimatet den nya byggnaden har. Vilka utsläpp byggfasen genererat. Den data som publiceras här är byggherrarnas egna siffror, hämtade ur de klimatdeklarationer som lämnats in till Boverket. BU-listan uppdateras löpande med nya projekt.',
        },
        {
          q: 'Syfte',
          a: 'Omställningen av byggindustrin sker för långsamt om Sverige ska nå målen i Parisavtalet. När klimatutsläppen från byggindustrin görs publik och lättåtkomlig ökar pressen på kommuner och byggherrar att minska klimatutsläppen från byggnation. Det blir också enklare för branschens aktörer att mäta sina framsteg över tid och jämfört med andra, samt att se hur långt de har kvar till de politiskt satta klimatmålen.',
        },
        {
          q: 'Initiativtagare',
          a: 'Byggutsläppsligan är skapad av ACAN Sverige, ett ideellt nätverk av aktiva inom byggd miljö, som verkar för att skapa ett hållbart samhällsbyggande inom de planetära gränserna. Differ Agency är samarbetspartner i projektet.',
        },
        {
          q: 'Om klimatdeklarationer',
          a: 'Lagen om klimatdeklarationer trädde i kraft den 1 januari 2022. Byggherrar är sedan dess skyldiga att redovisa vilken påverkan nya byggnader har innan de tas i bruk. Klimatpåverkan redovisas i kg CO2e/m2 bruttototalarea (BTA).',
          b: 'Klimatdeklarationerna visar inte hela sanningen. I nuläget behöver inte alla byggnader eller alla byggnadsdelar deklareras. De verkliga utsläppen är alltså ännu högre än de siffror vi presenterar här. Men, deklarationerna är en viktig indikation, och eftersom de är det system som valts för att följa utsläppen från byggnation i Sverige så har vi valt att tillgängliggöra siffrorna. Syftet är att förbättra kunskapsläget och därigenom driva förändring.',
          aLink: {
            text: 'Läs mer här',
            link: 'https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/',
          },
        },
        {
          q: 'Det som ingår',
          a: 'Endast nya byggnader berörs av kravet på klimatdeklaration. Det som ingår i beräkningen är byggnadens produktionsskede A1-A5:',
          aList: [
            'A1-A3  Produktion av material och produkter (i Sverige och utomlands)',
            'A4  Transporter av material till byggplatsen ',
            'A5  Materialspill, energi på byggplatsen till byggbodar, maskiner och verktyg ',
          ],
          b: 'De delar av byggnaden som ska ingå i en klimatdeklaration är byggnadens klimatskal, samtliga bärande konstruktionsdelar samt innerväggar. Den data som används för byggdelars klimatpåverkan är antingen generisk från Boverkets databas, eller specifik från inköpta byggprodukter.',
        },
        {
          q: 'Det som inte ingår',
          aList: [
            'Markarbeten, installationer och invändiga ytskikt. Dessa kan utgöra en avsevärd del av byggnadens totala klimatpåverkan',
            'Byggnaders upptag av växthusgaser.',
            'Rivning som kan föregå en nybyggnation eller ombyggnation av redan uppförda byggnader',
            'Byggnaders klimatpåverkan under bruksfasen, så som värme/kyla, drift och underhåll.',
          ],
          b: 'Byggnader som undantas helt från kravet att deklarera är:',
          bList: [
            'Byggnader som inte kräver bygglov',
            'Byggnader uppförda av privatpersoner som inte byggs inom näringsverksamhet',
            'Byggnader mindre än 100 m2',
            'Byggnader med tidsbegränsade bygglov',
            'Industribyggnader och verkstäder',
            'Ekonomibyggnader för jordbruk, skogsbruk eller liknande näring',
            'Byggnader avsedda för totalförsvaret och de som är av betydelse för Sveriges säkerhet',
            ' Byggnader som byggs av de statliga myndigheterna Svenska kraftnät, Fortifikationsverket, Statens fastighetsverk, Specialfastigheter Sverige AB eller Trafikverket',
          ],
        },
        {
          q: 'Om statistiken',
          a: 'Enligt Boverkets statistik släppte nybyggnation ut 4,075 miljoner ton CO2e under 2021. I klimatdeklarationerna är totalsiffran för drygt två år mindre än 200 000 ton CO2e. Varför?',
          b: 'De siffrorna går inte att jämföra rakt av då de tagits fram utifrån olika förutsättningar. Många byggnader och byggdelar är inte heller inkluderade i deklarationskraven, och deklarerade utsläpp är inte samma sak som faktiska utsläpp. (Se Det som ingår/ Det som inte ingår). Dessutom omfattar statistiken på Byggutsläppslistan bara de byggnader som både sökts bygglov för efter 1 jan 2022, och som färdigställts så att deklarationen har hunnit lämnas in. Detta ger en övervikt på byggnader med relativt kort produktionstid. (Exempelvis småhus och modulbyggnader.) Statistiken kommer alltså att förändras mycket, och bli mer korrekt, ju fler deklarationer som lämnas in. Ett antal byggnader finns i listan där de deklarerade utsläppen är = 0. Vad vi kan se handlar detta till största del om modulbyggnader, som helt enkelt ställts på ny plats.',
          c: 'Det kan också finnas en del fel i beräkningarna. En deklaration sticker ut med sin höga mängd deklarerade utsläpp. Vi misstänker räknefel, och har frågat Boverket som inte har mer information om det aktuella fallet. Vi har valt att ändå ha med deklarationen på Byggutsläppslistan för att statistiken ska vara komplett.',
        },

        {
          q: 'Om gränsvärden',
          a: 'Boverket föreslår att gränsvärden för maximalt utsläpp av växthusgaser införs redan 2025. <a href="https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/nyheter/gransvarde-klimatpaverkan/" target="_blank">(Slutredovisning av Gränsvärde för byggnaders klimatpåverkan och en utökad klimatdeklaration, Boverket)</a>',
          b: 'Gränsvärdet föreslås att omfatta samtliga byggdelar av en byggnad från grunden och dess isolering exklusive solceller och fast utrustning. Man föreslår även utökade krav i reglerna så att alla skeden av byggnadens livscykel och flera delar av byggnaden ska redovisas, bland annat installationer. Gränsvärdet avgränsas till att omfatta byggskedet.',
        },
      ],
      QAListEnglish: [
        {
          q: 'About the Embodied Carbon Declared website',
          a: 'Embodied Carbon Declared is a website that perhaps for the first time in the world publishes the data on CO2e emissions from new construction at project level. The list publishes declared emissions linked to Swedish construction projects - at project, municipality and developer level.',
          b: 'The data that is published is taken from the Swedish National Board of Housing, Building and Planning (Boverket) and is based on the climate declarations that developers, since January 2022, are required by law to submit for new construction.',
          aLink: {
            text: 'Read more',
            link: 'https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/',
          },
        },
        {
          q: 'Background',
          a: 'Since January 1, 2022, it has been a requirement in Sweden to declare the climate impact of new construction projects. The data published are developers’ figures submitted to Boverket. The website is continuously updated with new projects.',
        },
        {
          q: 'Purpose',
          a: 'Sweden’s construction sector is transforming too slowly to reach the targets in the Paris Agreement. When climate emissions from the construction industry are made public and easily accessible, the pressure on municipalities and developers to reduce climate emissions from construction increases.',
        },
        {
          q: 'Initiators',
          a: 'Embodied Carbon Declared was created by ACAN Sweden, a non-profit network of active people in the built environment, which works to create sustainable construction within the planetary boundaries. Differ Agency is a partner in the project.',
        },
        {
          q: 'About climate declarations',
          a: 'The Act on Climate Declarations entered into force on 1 January 2022. Since then, builders have been obliged to report the impact of new buildings before they are put into use. The climate impact is reported in kg CO2e/m2 gross total space (BTA).',
          b: 'The climate declarations do not show the whole truth. Currently, not all buildings or all building parts need to be declared. The real emissions are thus even higher than the figures we present here. However, the declarations are an important indicator, and since they are the system chosen to monitor emissions from construction in Sweden, we have chosen to make the figures easily accessible. The aim is to improve the state of knowledge and thereby drive change.',
          aLink: {
            text: 'Read more',
            link: 'https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/',
          },
        },
        {
          q: 'What’s included',
          a: 'Only new buildings are affected by the requirement for a climate declaration. What is included in the calculation is the building’s production stage A1-A5:',
          aList: [
            'A1-A3 Production of materials and products (in Sweden and abroad)',
            'A4 Transport of materials to the construction site',
            'A5 Material waste, energy on the construction site for construction sheds, machines, and tools',
          ],
          b: 'The building components that must be included in a climate declaration are the building’s envelope, all load-bearing structural parts, and interior walls. The data used for building components’ climate impact is either generic from the Swedish National Board of Housing, Building and Planning (Boverket) database or specific from purchased building products.',
        },
        {
          q: 'What’s not included',
          aList: [
            'Earthworks, installations, and interior finishes. These can constitute a considerable part of the building’s total climate impact.',
            'Biogenic carbon stored in buildings.',
            'Demolition that may precede a new construction or remodeling of already erected buildings.',
            'The climate impact of buildings during the use phase, such as heating/cooling, operation and maintenance.',
          ],
          b: 'Buildings that are completely exempt from the requirement to declare are:',
          bList: [
            'Buildings that do not require planning permission',
            'Buildings erected by private individuals that are not built as part of commercial activities',
            'Buildings less than 100 m2',
            'Buildings with temporary building permits',
            'Industrial buildings and workshops',
            'Buildings for agriculture, forestry, or similar industries',
            'Buildings intended for total defense and those that are of importance to Sweden’s security',
            'Buildings built by the government authorities Svenska kraftnät, the Fortifications Agency, the Swedish Property Agency, Specialfastigheter Sverige AB or the Swedish Transport Administration',
          ],
        },
        {
          q: 'About the statistics',
          a: 'According to statistics from the Swedish National Board of Housing, Building and Planning (Boverket), new construction released 4.075 million tons of CO2e in 2021. In the climate declarations, the total figure for just over two years is significantly lower than 200,000 tons of CO2e. Why?',
          b: 'Those figures cannot be directly compared as they were calculated based on different conditions. Many buildings and building components are also not included in the declaration requirements and declared emissions are not the same as actual emissions. (See What is included/ What is not included). In addition, the statistics on Embodied  Carbon Declared only include buildings completed after 1 January 2022. Larger projects, with construction times longer than the two years since the law was enacted, are not yet reflected in the statistics. This results in a preponderance of buildings with a relatively short production time. (For example, detached houses and modular buildings.) The statistics will therefore become more accurate and representative as more declarations are submitted. Some buildings in the list have declared emissions = 0. From what we can see, this mostly concerns modular buildings, which have simply been put in a new location.',
          c: 'There may also be some errors in the calculations. For instance, one declaration stands out with its unusually high amount of declared emissions. We suspect a calculation error and have asked Boverket, which unfortunately does not have more information about the current case. We have chosen to still include the declaration on the website for the statistics to be complete.',
        },

        {
          q: 'About limit values',
          a: 'The Swedish National Board of Housing, Building and Planning (Boverket) proposes that limit values for greenhouse gas emissions in the construction phase be introduced as early as 2025 <a href="https://www.boverket.se/sv/klimatdeklaration/om-klimatdeklaration/nyheter/gransvarde-klimatpaverkan/" target="_blank">(Final report of Limit value for buildings’ climate impact and an extended climate declaration, Swedish National Board of Housing, Building and Planning)</a>',
          b: 'The limit value would include all components of a building from the ground up and its insulation excluding solar cells and fixed equipment. Boverket has also proposed expanded requirements in the rules so that all stages of the building’s life cycle, as well as several parts of the building including installations, must be reported.',
        },
      ],
    };
  },
  methods: {
    toggleAnswer(index) {
      this.shownAnswer = this.shownAnswer === index ? null : index;
    },
  },
  computed: {
    currentQAList() {
      return this.isEnglish ? this.QAListEnglish : this.QAListSwedish; // Return the appropriate QA list based on the language
    },
  },
};
</script>

<style scoped>
.QA-molecule {
  margin-top: 40px;
}
h2 {
  display: flex;
  justify-content: center;
}

.QA-molecule__questions {
  margin-top: 20px;

  letter-spacing: 1.2px;
  margin: auto;
  line-height: 1.4em;
}
.QA-mole .QA-molecule__questions__wrapper {
  cursor: pointer;
}
.QA-molecule__questions__wrapper__question {
  font-size: 18px;
  font-family: 'fet', sans-serif;
  display: flex;
  align-items: center;
  padding-right: 20px;
  padding: 10px 20px 10px 0;
  cursor: pointer;
}
.QA-molecule__questions__wrapper__answer,
.QA-molecule__questions__wrapper_link {
  padding: 0 20px 20px 50px;
  font-family: 'bred', sans-serif;
  color: white;
  line-height: 1.4em;
  letter-spacing: 1px;
  font-size: 18px;
  margin-bottom: 0;
  max-width: 800px;
}

.QA-molecule__questions__wrapper_link:hover {
  color: #2637f3; /* Change this to the desired blue color */
}
.QA-molecule__questions__wrapper__listAnswer {
  font-family: 'bred', sans-serif;
  color: white;
  font-size: 18px;
  margin-bottom: 10px;
  line-height: 1.4em;
}
.bi {
  margin: 0 10px;
  font-size: 30px;
  color: #787878;
}

@media all and (min-width: 1024px) {
  .QA-molecule__questions {
    width: 100%;
    float: left;
  }
}
</style>
